export default __webpack_public_path__ + "static/media/gallery3.80e5d72e.jpg";